export const environment = {
  production: true,
  imageUrl : 'https://www.gaeasoft.co.kr:10081',
  // securityUrl : 'http://183.98.48.60:10090',
  securityUrl : 'https://be.gaeasoft.co.kr:10090',
  userUrl : 'https://be.gaeasoft.co.kr:10084',
  registrationUrl : 'https://be.gaeasoft.co.kr:10082',
  userClientUrl : 'https://be.gaeasoft.co.kr:10085',
  clientId : '1500960511557ca14c4c',
  clientSecret : '0e7a9a4ff6d046e18ed5f174c8f80c53',
  secret : 'secret',
  redirectUrl : 'http://' + window.location.host,
  convertUrl : 'http://img.gaeasoft.io/convert/'
};



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/environments/environment.ts